import React from 'react';

/**
 * Provides aggregated grain_bin_sites data from a special viewer's child accounts
 * to both GrainOperations and ManageSitesView, bypassing their own
 * withGetGrainBinSitesHoc queries which would return empty for special viewer accounts.
 *
 * Set by GrainOperationsRoutes (wraps both routes so data persists across navigation).
 * Read by GrainOperations and ManageSitesView.
 *
 * Value shape:
 *   null  — not in aggregated mode (normal single-account user)
 *   { loading: true, sites: [] } — aggregated mode, fetch in progress
 *   { loading: false, sites: [...] } — aggregated mode, data ready
 */
export type AggregatedSitesContextValue = { loading: boolean; sites: any[] } | null;

export const AggregatedSitesContext = React.createContext<AggregatedSitesContextValue>(null);
